/**
 * 产品购买按钮 — 随变体切换更新库存状态与 variant-id。
 */
(function () {
  "use strict";

  if (window.__productBuyButtonsBound) return;
  window.__productBuyButtonsBound = true;

  function setAvailability(root, available) {
    var actions = root.querySelector("[data-buy-buttons-actions]");
    var soldOut = root.querySelector("[data-buy-buttons-sold-out]");

    if (actions) actions.hidden = !available;
    if (soldOut) soldOut.hidden = available;
    root.dataset.available = available ? "true" : "false";
  }

  function setVariantId(root, variantId) {
    if (!variantId) return;

    var drawer = root.querySelector("open-cart-drawer");
    var shopNow = root.querySelector("add-to-cart[data-buy-now]");

    if (drawer) drawer.setAttribute("variant-id", variantId);
    if (shopNow) shopNow.setAttribute("variant-id", variantId);
  }

  function initRoot(root) {
    if (!root || root.dataset.buyButtonsInit === "1") return;
    root.dataset.buyButtonsInit = "1";
  }

  function onVariantChange(event) {
    var detail = event.detail || {};

    if (!("variant" in detail)) return;

    // variant 为 null 表示当前选项组合买不到，按缺货处理
    var variant = detail.variant;

    document.querySelectorAll("[data-product-buy-buttons]").forEach(function (root) {
      if (variant) setVariantId(root, variant.id);
      setAvailability(root, !!(variant && variant.available));
    });
  }

  function init(scope) {
    (scope || document)
      .querySelectorAll("[data-product-buy-buttons]")
      .forEach(initRoot);
  }

  document.addEventListener("product:variant:change", onVariantChange);
  document.addEventListener("DOMContentLoaded", function () {
    init(document);
  });
  document.addEventListener("shopify:section:load", function (event) {
    init(event.target);
  });
})();
